module.exports = __webpack_public_path__ + "img/project2@2x.c304eae7.jpg";